module.exports = __webpack_public_path__ + "img/04.495dca35.png";